import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { SPECIAL_PRODUCT_TYPES } from 'swag-common/constants/product.constants';
import { MOCKUP_BOX_NOTECARD_HIDDEN_CONTAINER_ID } from 'swag-client-common/constants/html-to-image';
import { generateImageFromHtml } from 'swag-client-common/utils/generate-image-from-html';
import { BOX_NOTECARD_STEPS } from '../../../../../redux/box-notecard-editor/box-notecard-editor.reducer';
import { resetPopup, moveToPopupStep, updateNotecardTextContent, setBoxNotecardDefaultImage, setBoxNotecardLoading } from '../../../../../redux/box-notecard-editor/box-notecard-editor.actions';
import { toggleSpecialProductInBox } from '../../../../../redux/box-builder/box-builder.actions';
import { boxNotecardColorSelector, boxNotecardLogoPreviewSelector, boxNotecardTextContentSelector, selectedBoxItemsIdSelector, isLoadingSelector } from '../../../../../redux/box-notecard-editor/box-notecard-editor.selectors';
import { TextEditorStepComponent } from './text-editor-step';
const mapStateToProps = createStructuredSelector({
  boxItemsId: selectedBoxItemsIdSelector,
  color: boxNotecardColorSelector,
  logo: boxNotecardLogoPreviewSelector,
  textContent: boxNotecardTextContentSelector,
  isLoading: isLoadingSelector
});
const mapDispatchToProps = dispatch => ({
  onNext: async (boxItemsId, mockupContainer) => {
    //CREATE OR UPDATE NOTECARD ITEM AND UPDATE CART
    dispatch(setBoxNotecardLoading(true));
    if (mockupContainer) {
      const imgUrl = await generateImageFromHtml({
        mockupContainer,
        hiddenContainerId: MOCKUP_BOX_NOTECARD_HIDDEN_CONTAINER_ID
      });
      if (imgUrl) {
        dispatch(setBoxNotecardDefaultImage(imgUrl));
      }
    }
    dispatch(toggleSpecialProductInBox(boxItemsId, SPECIAL_PRODUCT_TYPES.BOX_NOTECARD, {
      isNotecardPicked: true
    }));
    dispatch(hidePopup());
    dispatch(resetPopup());
  },
  onBack: () => {
    dispatch(moveToPopupStep(BOX_NOTECARD_STEPS.LOGO_AND_COLOR));
  },
  handleNotecardTextContentChange: html => {
    dispatch(updateNotecardTextContent(html));
  }
});
export const TextEditorStep = connect(mapStateToProps, mapDispatchToProps)(TextEditorStepComponent);